import { Box, FormControl, Grid } from '@mui/material';
import { DetailButton, ErrorTypography, StyledFormLabel } from 'components/atoms';
import {
  OptionFieldProps,
  withGridItemCSS,
  withWrapperCSS,
} from 'components/organisms/forms/form-builder/types';
import { noop } from 'lodash';
import React, { FC, useEffect, useState } from 'react';

export const ToggleDetailButtons: FC<
  OptionFieldProps<string> & withGridItemCSS & withWrapperCSS
> = ({
  error,
  fieldKey,
  gridItemCss,
  initValue = '',
  label = '',
  onChange = noop,
  options,
  required = false,
  wrapperCss,
  xs = 12,
  labelCss,
  disabled = false,
}) => {
  const [selected, setSelected] = useState(initValue);

  useEffect(() => {
    setSelected(initValue);
  }, [initValue]);

  const handleOnClick = (value: string) => {
    setSelected(value);
    onChange(value, fieldKey);
  };

  return (
    <Grid item xs={xs} style={gridItemCss}>
      <FormControl
        error={!!error}
        required={required}
        style={{ width: '88%', ...wrapperCss }}
      >
        <StyledFormLabel error={!!error}>
          {label && (
            <label>
              {label} {required ? '*' : null}
            </label>
          )}
        </StyledFormLabel>
        <Box style={{ display: 'flex', flexDirection: 'row' }}>
          {options.map(({ name, description }, index) => (
            <DetailButton
              key={`detail-button-${index}-name`}
              // @ts-ignore
              selected={selected === name}
              variant="outlined"
              onClick={() => handleOnClick(name.toString())}
              value={name}
              aria-pressed={selected === name}
              style={{ ...labelCss }}
              disabled={disabled}
            >
              {description}
            </DetailButton>
          ))}
        </Box>
        <ErrorTypography>{error}</ErrorTypography>
      </FormControl>
    </Grid>
  );
};
